import ReporteFotografico from "../../components/ReporteFotografico";
import ReporteFotograficoExterno from "../../components/ReporteFotografico/ReporteFotograficoExterno";

export const ReporteFotograficoPage = () => <ReporteFotografico />;
export const ReporteFotograficoExternoPage = () => <ReporteFotograficoExterno />;
